import { useEffect } from "react";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";

import { useAuthStore } from "../store/authStore";
import { INACTIVITY_MESSAGE } from "../utilities/authMessages.js";

// Watches for session expiry (flagged by the axios 401 interceptor or the
// activity heartbeat) and centralizes the toast + redirect-to-login for it,
// regardless of which of those two triggered it.
const SessionExpiredWatcher = () => {
  const sessionExpired = useAuthStore((state) => state.sessionExpired);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionExpired) return;

    toast.error("Your session has expired due to inactivity.", {
      duration: 5000,
      position: "top-center",
      id: "session-expired",
    });

    // The flag is deliberately NOT cleared here: react-router defers this
    // navigation via startTransition, so clearing now would commit first and
    // un-gate ProtectedRoute while it is still mounted, letting it fire its
    // own toast and a state-less redirect. LoginPage clears it on arrival.
    navigate("/auth", {
      replace: true,
      state: { message: INACTIVITY_MESSAGE },
    });
  }, [sessionExpired, navigate]);

  return null;
};

export default SessionExpiredWatcher;
